import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './ThemeContext';
import Header from './components/Header';
import Dashboard from './pages/Dashboard';
import ClusterDetail from './pages/ClusterDetail';
import Search from './pages/Search';
import Activity from './pages/Activity';
import TopRequests from './pages/TopRequests';
import Health from './pages/Health';
import Feed from './pages/Feed';
import Login from './pages/Login';

function AppContent() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('feedback_token');
    setIsAuthenticated(!!token);
    setChecking(false);
  }, []);

  if (checking) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: 'var(--bg-secondary)',
      }}>
        <p style={{ color: 'var(--text-muted)' }}>Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <div className="min-h-screen bg-coros-bg-secondary">
      <Header onLogout={() => setIsAuthenticated(false)} />
      <main>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/clusters/:id" element={<ClusterDetail />} />
          <Route path="/search" element={<Search />} />
          <Route path="/feed" element={<Feed />} />
          <Route path="/activity" element={<Activity />} />
          <Route path="/top-requests" element={<TopRequests />} />
          <Route path="/health" element={<Health />} />
          <Route path="/login" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
